var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { button } from '../styles';
export var Button = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    ", ";\n\n    &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n    }\n"], ["\n    width: 100%;\n    ", ";\n\n    &:disabled {\n        opacity: 0.5;\n        cursor: not-allowed;\n    }\n"])), button);
var templateObject_1;
